import { Text } from "@medusajs/ui"

import InteractiveLink from "@modules/common/components/interactive-link"

type RailComponentProps = {
  children?: React.ReactNode
  title?: string
  hideTitle?: boolean
  href?: string
  hrefLabel?: string
}

export const MarketRailComponentItem = ({ children }: { children: React.ReactNode }) => {
  return <li>{children}</li>
}

export default function MarketRailComponent({ children, title, hideTitle, href, hrefLabel }: RailComponentProps) {
  return (
    <div className="content-container relative mb-[20px] rounded-[40px] bg-white p-0 lg:mb-0 lg:py-[40px]">
      <div className="flex items-end justify-between px-[21px] lg:mb-[32px] lg:px-[40px]">
        {!hideTitle && <Text className="font-manrope text-[18px] font-bold lg:text-[40px] lg:leading-[48px]">{title}</Text>}
        <div className="flex grow justify-end">{!!href && !!hrefLabel && <InteractiveLink href={href}>{hrefLabel}</InteractiveLink>}</div>
      </div>
      <ul className="overflow-visible px-[21px] lg:pl-[40px] lg:pr-0">{children}</ul>
    </div>
  )
}
